import dayjs, { Dayjs } from "dayjs";
import Dropdown from 'react-bootstrap/Dropdown'
import "react-dropdown/style.css";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { useCallback, useEffect, useState } from "react";
import DropBox from "../../custom/DropBox";
import { showDangerToast } from "../../constants/toaster";
import { s3 } from "../../constants/awsConfig";
const imageFileTypes = ["image/png", "image/gif", "image/jpeg"];

export const AddLiveReelCategory = (props) => {

  const [typeDropdownText, setTypeDropdownText] = useState({
    id: 'LIVE_STREAMING',
    value: 'Live Streaming'
  })

  useEffect(() => {
    if (props?.bannerFormData?.id) {
      console.log(props?.bannerFormData)
      if (props.bannerImage) {
        props.setThumbanailControl({
          showError: false,
          errorMessage: "",
          showImage: props?.bannerFormData?.icon ? true : false,
          imageData: { src: props?.bannerFormData?.icon },
        });
      }
      if (props?.bannerFormData?.type) {
        if (props?.bannerFormData?.type === 'LIVE_STREAMING') {
          setTypeDropdownText({
            id: 'LIVE_STREAMING',
            value: 'Live Streaming'
          })
        } else if (props?.bannerFormData?.type === 'PODCAST') {
          setTypeDropdownText({
            id: 'PODCAST',
            value: 'Podcast'
          })
        } else if (props?.bannerFormData?.type === 'RADIO') {
          setTypeDropdownText({
            id: 'RADIO',
            value: 'Radio'
          })
        }
      }
    }
  }, [props.show]);
  const [value, setValue] = useState(dayjs());
  const [images, setImages] = useState([]);
  const [files, setFiles] = useState([]);

  const [startDate, setStartDate] = useState(new Date("2023-10-16T06:23:56"));
  const [endDate, setEndDate] = useState();
  const [startDateChanged, setStartDateChanged] = useState(false);


  const uploadFileToAWS = async (selectedFile) => {
    if (!selectedFile) return;

    const params = {
      Bucket: 'supa-dev-bucket', // bucket name
      Key: `uploads/${selectedFile.name}`,
      Body: selectedFile,
      ContentType: selectedFile.type,
      // ACL: 'public-read', // Adjust according to your needs
    };

    try {
      const data = await s3.upload(params).promise();
      const url = data.Location.replace(
        "https://supa-dev-bucket.s3.af-south-1.amazonaws.com/",
        "https://d2up68x544gew2.cloudfront.net/"
      );
      return { success: true, url: url }
    } catch (error) {
      console.error('Error uploading file:', error);
      return { success: false }
    }
  };


  const handleSubmit = async () => {
    if (props?.bannerFormData?.id) {
      if (
        props?.bannerFormData?.name &&
        typeDropdownText?.id
      ) {
        if (props?.bannerImage) {
          const isImageUploaded = await uploadFileToAWS(props.bannerImage)
          if (isImageUploaded.success) {
            props.onSubmit(isImageUploaded.url);
          } else {
            showDangerToast("Image upload failed.");
          }
        } else {
          if (props?.thumbanailControl.imageData?.src) {
            props.onSubmit(props?.thumbanailControl.imageData?.src);
          } else {
            showDangerToast("Thumbnail is required.");
          }
        }
      } else {
        showDangerToast("Please fill all required Fields.");
      }
    } else {
      if (
        props?.bannerFormData?.name &&
        typeDropdownText?.id &&
        props?.bannerImage
      ) {
        const isImageUploaded = await uploadFileToAWS(props.bannerImage)
        if (isImageUploaded.success) {
          props.onSubmit(isImageUploaded.url);
        } else {
          showDangerToast("Image upload failed.");
        }
      } else {
        showDangerToast("Please fill all required Fields.");
      }
    }
  };

  const onDrop = useCallback((acceptedFiles) => {
    acceptedFiles.map((file, index) => {
      if (imageFileTypes.includes(file.type)) {
        const reader = new FileReader();
        reader.onload = function (e) {
          setImages((prevState) => [
            ...prevState,
            { id: index, src: e.target.result },
          ]);
          props?.setBannerImage(file);
          props.setThumbanailControl({
            showError: false,
            errorMessage: "",
            showImage: true,
            imageData: { id: index, src: e.target.result },
          });
        };
        reader.readAsDataURL(file);

        return file;
      } else {
        props.setThumbanailControl({
          showError: true,
          errorMessage: "Only Image file is accept. ",
          showImage: false,
          imageData: [],
        });
      }
    });
  }, []);

  useEffect(() => {
    props.setThumbanailControl({
      showError: true,
      errorMessage: "",
      showImage: props?.bannerFormData?.icon ? true : false,
      imageData: { src: props?.bannerFormData?.icon },
    });
    props.setFilterFileControl({
      showError: true,
      errorMessage: "",
      showImage: true,
      imageData: { src: props?.bannerFormData?.icon },
    });
  }, [props?.show === true]);

  const clickToRemove = () => {
    props?.setBannerImage(null)
  }

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter">
          {props?.bannerFormData?.id ? "Update Live Category" : "Add Live Category"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          <div className="col-md-6">
            <Form.Control
              value={props.bannerFormData?.name}
              onChange={(e) =>
                props.setBannerFormData({
                  ...props?.bannerFormData,
                  name: e.target.value,
                })
              }
              placeholder="Name"
              aria-label="Small"
              aria-describedby="inputGroup-sizing-sm"
            />
            {!props?.bannerFormData?.name ? (
              <label className="custom-error-label">
                Name is required*
              </label>
            ) : (
              <></>
            )}
          </div>
          <div className="col-md-6">
            <Dropdown>
              <Dropdown.Toggle
                variant='success'
                style={{
                  backgroundColor: 'white',
                  color: 'black',
                  border: '1px solid #cad1d7',
                  boxShadow: 'none',
                  transform: 'none'
                }}
                id='dropdown-basic'
              >
                {typeDropdownText?.value}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item
                  onClick={() => {
                    setTypeDropdownText({
                      id: 'LIVE_STREAMING',
                      value: 'Live Streaming'
                    })
                    props?.setBannerFormData({
                      ...props?.bannerFormData,
                      type: 'LIVE_STREAMING'
                    })
                  }
                  }
                >
                  Live Streaming
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => {
                    setTypeDropdownText({
                      id: 'PODCAST',
                      value: 'Podcast'
                    })
                    props?.setBannerFormData({
                      ...props?.bannerFormData,
                      type: 'PODCAST'
                    })
                  }
                  }
                >
                  Podcast
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => {

                    setTypeDropdownText({
                      id: 'RADIO',
                      value: 'Radio'
                    })
                    props?.setBannerFormData({
                      ...props?.bannerFormData,
                      type: 'RADIO'
                    })
                  }
                  }
                >
                  Radio
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-md-6">
            Upload Icon*
            <DropBox
              onDrop={onDrop}
              acceptType="image/*"
              isImage={true}
              thumbanailControl={props?.thumbanailControl}
              setThumbanailControl={props?.setThumbanailControl}
              clickToRemove={clickToRemove}
            />
            {props.thumbanailControl?.showError ? (
              <label className="custom-error-label" style={{ color: "red" }}>
                {" "}
                {props.thumbanailControl?.errorMessage}
              </label>
            ) : (
              <></>
            )}
            {props?.bannerFormData?.id ? (
              <></>
            ) : props?.bannerImage === null ? (
              <label className="custom-error-label">
                Icon is required*
              </label>
            ) : (
              <></>
            )}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outlined" onClick={props.onHide}>
          Cancel
        </Button>
        <Button onClick={handleSubmit}>Submit</Button>
      </Modal.Footer>
    </Modal>
  );
};
